import { useNavigate } from "react-router";
import { Button, Stack, Text, Title } from "@mantine/core";
import { LinkSentIcon } from "../../shared/svg";
import { useTranslation } from "react-i18next";

export const PasswordUpdatedPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Stack align="stretch" justify="center" gap="24px">
      <center>
        <LinkSentIcon />
      </center>
      <Title size={36}>{t("password_updated_title")}</Title>
      <Text c="dimmed" size="md">
        {t("password_updated_description")}
      </Text>
      <Button fullWidth onClick={() => navigate("/login/sign-in")}>
        {t("back_to_log_in")}
      </Button>
    </Stack>
  );
};
